import useMusioApi from "@/contexts/client/musio-client-context";
import usePaddle from "@/contexts/paddle/paddle-context";
import { cn } from "@/utils/utils";
import { type MouseEventHandler } from "react";

export default function CancelSubscriptionRetain({ className }: { className?: string }) {
  const { musioApi } = useMusioApi();
  const paddle = usePaddle();
  const { data } = musioApi.useQuery("get", "/user/recurring");

  const subscriptionId = data?.subscriptionId!;

  const handleSubmit: MouseEventHandler<HTMLParagraphElement> = async () => {
    console.log("Paddle retain starting");
    const retainResult = await paddle?.Retain.initCancellationFlow({
      subscriptionId, // NOTE: this should be defined if because we're in a protected route
    });
    console.log(retainResult);
  };

  return (
    <p
      className={cn("underline cursor-pointer text-sm font-normal mt-2 p-2 text-musio-red", className)}
      onClick={handleSubmit}
    >
      Cancel Subscription - Retain
    </p>
  );
}

